import React from "react";
// Adjust this path to your actual image location
import logo from "../../assests/images/family-photo.webp";
import { Box, Typography, Container, Card, CardMedia } from "@mui/material";

const WhyImRunning = () => {
  return (
    <Box sx={{ py: 10, bgcolor: "#FFF", width: "100%" }}>
      <Container maxWidth="lg">
        {/* Main Flex Wrapper - Replaces Grid */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
            // alignItems: "center",
            gap: { xs: 6, md: 10 }, // Space between image and text
          }}
        >
          {/* Left Side: Image Container */}
          <Box sx={{ flex: 1, position: "relative", width: "100%" }}>
            <Card
              sx={{
                borderRadius: "12px",
                boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                overflow: "hidden",
                border: "none",
                maxHeight: "700px",
              }}
            >
              <CardMedia
                component="img"
                src={logo}
                alt="Gary Taylor and Family"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </Card>

            {/* "Family First" Overlay Box */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                bgcolor: "#051328",
                color: "#FFF",
                p: 3,
                width: "45%",
                borderTopRightRadius: "12px",
                borderBottomLeftRadius: "12px",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 800,
                  fontStyle: "italic",
                  fontSize: "1.1rem",
                  mb: 0.5,
                  lineHeight: 1.2,
                }}
              >
                Family First
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  opacity: 0.9,
                  display: "block",
                  lineHeight: 1.4,
                  fontSize: "0.85rem",
                }}
              >
                Proud husband and father - family is at the heart of everything
                I do.
              </Typography>
            </Box>
          </Box>

          {/* Right Side: Text Content */}
          <Box sx={{ flex: 1, width: "100%" }}>
            <Typography
              sx={{
                color: "#C59324",
                fontWeight: 700,
                letterSpacing: "0.2em",
                display: "block",
                mb: 2,
                fontSize: "0.85rem",
                textTransform: "uppercase",
              }}
            >
              Why I'm Running
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#051328",
                fontWeight: 700,
                fontSize: { xs: "2.2rem", md: "3.2rem" },
                lineHeight: 1.1,
              }}
            >
              Middletown Deserves a
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#C59324",
                fontStyle: "italic",
                fontWeight: 500,
                fontSize: { xs: "2.2rem", md: "3.2rem" },
                mb: 4,
                lineHeight: 1.1,
              }}
            >
              Voice That Listens
            </Typography>

            <Box sx={{ color: "#444", mb: 4 }}>
              <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.8 }}>
                Thank you for visiting. Campaigning for elected office was not
                on my bingo card for 2026. The closest I've come to politics is
                serving as HOA president for the last 15 years.
              </Typography>

              <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.8 }}>
                I could no longer sit on the sidelines while decisions made in
                Dover continued to negatively impact our families, small
                businesses, and public safety here in Middletown.
              </Typography>

              <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.8 }}>
                My commitment is simple: understand the issues, explain them
                clearly, and vote in the best interest of our community - not
                based on party bosses.
              </Typography>
            </Box>

            {/* Blockquote Section */}
            <Box
              sx={{
                p: 3,
                bgcolor: "#FEF9EF",
                borderLeft: "4px solid #B48B3D",
              }}
            >
              <Typography
                sx={{
                  fontStyle: "italic",
                  color: "#333",
                  fontFamily: "'Playfair Display', serif",
                  fontSize: "1.2rem",
                  lineHeight: 1.5,
                }}
              >
                "Does this make sense for us in Middletown?" - That's the only
                test that matters.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default WhyImRunning;
